export const initialState = {
  step: 'gate',
  method: null,
  fromVersion: null,
  toVersion: null,
  progress: 0,
  error: null,
};

export function update(state, event) {
  switch (event.type) {
    case 'GATE_OK':
      return { ...state, step: 'detecting' };
    case 'GATE_BLOCKED':
      return { ...state, step: 'blocked' };
    case 'DETECTED':
      return event.needsUpdate
        ? {
            ...state,
            step: 'confirm',
            method: event.method,
            fromVersion: event.fromVersion,
            toVersion: event.toVersion,
          }
        : { ...state, step: 'upToDate', method: event.method, fromVersion: event.fromVersion };
    case 'DETECT_NO_PORT':
      return { ...state, step: 'driversHelp' };
    case 'CONFIRM':
      return { ...state, step: 'updating', progress: 0, error: null };
    case 'PROGRESS':
      return { ...state, progress: event.progress };
    case 'FLASH_DONE':
      return { ...state, step: 'verifying' };
    case 'VERIFIED':
      return { ...state, step: 'done', toVersion: event.toVersion };
    case 'ROLLED_BACK':
      return { ...state, step: 'rolledBack' };
    case 'ERROR':
      return {
        ...state,
        step: 'error',
        error: {
          step: event.step,
          reason: event.reason,
          fatal: !!event.fatal,
          attempt: (state.error?.attempt || 0) + 1,
        },
      };
    case 'RETRY':
      return { ...state, step: state.error?.step || 'gate', error: null };
    case 'CANCEL':
      return initialState;
    default:
      return state;
  }
}
